module.exports = __webpack_public_path__ + "static/media/paw.16b78853.png";